import React, { useEffect, useState } from 'react';
import './index.scss';
import axios from 'axios';
import Utils from '../../CourseApp/Helper/utils';
import manager from '../../Manager';

function UrlControl({ structure, saveValue, defaultValue, selectedSlide }) {


    const [controlValue, setControlValue] = useState(defaultValue ?? '');
    // const controlType = structure.relatedRequired.length > 0 && structure.relatedRequired.includes(selectedSlide.data.platform);
    const controlType = selectedSlide.data.platform !== "files" && "url";
    // console.log('url type => ' + structure.type);
    // console.log('url controlType => ' + controlType);
    // console.log('url platform => ' + JSON.stringify(selectedSlide.data));
    // const relatedRequired = structure.relatedRequired[0];
    const baseUrl = manager.settings.baseUrl;
    const videoQueryUrl = baseUrl + '/getVideoDuration';
    const controlLabel = selectedSlide.data.platform === 'bunnynet' ? "Embed Player Url" : structure.labelOnChangeOption;
    const controlClassAdded = selectedSlide.data.platform === 'bunnynet' ? "embed" : "";

    const handleChange = (e) => {
        if (typeof selectedSlide.data.platform === 'undefined') {
            return false;
        }

        let currentValue = e.currentTarget.value;
        let isUrlVideoNeedCheck = false;
        if (currentValue.length > 0) {
            if (!checkUrlIsValid(currentValue)) {
                // action if not valid
                e.currentTarget.className = 'form-control is-invalid text-danger';
            } else {
                isUrlVideoNeedCheck = true;
                e.currentTarget.className = 'form-control';
            }
        }

        setControlValue(currentValue);
        saveValue(currentValue);
        if (isUrlVideoNeedCheck) {
            if (selectedSlide.data.platform === 'youtube') {
                getVideoDuration(currentValue);
            }
            else {
                selectedSlide.duration = selectedSlide.template.getDuration();
            }
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleChange(event);
        }
    }

    const checkUrlIsValid = (urlInput) => {
        let regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
        return regex.test(urlInput);
    };

    const getVideoDuration = (videoUrl) => {
        axios
            .post(videoQueryUrl, {
                platform: selectedSlide.data.platform,
                url: videoUrl,
            })
            .then((response) => {
                let responseData = response.data;
                let errCode = responseData.errCode;
                let errMessage = responseData.errMessage;
                let data = responseData.data;
                if (errCode > 0) {
                    Utils.showError(errMessage);
                }
                if (errCode === 0) {
                    selectedSlide.duration = data;
                }
            })
            .catch((error) => {
                Utils.showError('An error occurred while uploading the file:' + error);
            });
    }

    useEffect(() => {
        if (typeof defaultValue !== 'undefined') {
            setControlValue(defaultValue);
        } else {
            setControlValue('');
        }
    }, [defaultValue]);

    return (
        <>
            {controlType && (
                <>
                    <div className="tbcourse-editor-control-item-label">
                        {controlLabel}
                    </div>
                    <div className={`tbcourse-editor-control-url ${controlClassAdded}`}>
                        <input
                            type="text"
                            className="form-control"
                            value={controlValue}
                            onChange={handleChange}
                            // onBlur={handleSave}
                            onKeyDown={handleKeyDown}
                        />
                        <small className='form-text'>{structure.helpText}</small>
                    </div>
                </>
            )}
        </>
    );
}

export default UrlControl;
